import { render, staticRenderFns } from "./BeltDisplay.vue?vue&type=template&id=7b84cd47&scoped=true"
import script from "./BeltDisplay.vue?vue&type=script&lang=js"
export * from "./BeltDisplay.vue?vue&type=script&lang=js"
import style0 from "./BeltDisplay.vue?vue&type=style&index=0&id=7b84cd47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b84cd47",
  null
  
)

export default component.exports